import { RoleViewMode } from '../types/auth';

export const ROLE_VIEW_MODE_STORAGE_KEY = 'devrain-time-role-view-mode';
export const TIME_VIEW_MODE_HEADER = 'X-Time-View-Mode';

export const getStoredRoleViewMode = (): RoleViewMode => {
  const storedMode = localStorage.getItem(ROLE_VIEW_MODE_STORAGE_KEY);
  return storedMode === 'User' || storedMode === 'ReportViewer' ? storedMode : 'Admin';
};

export const setStoredRoleViewMode = (mode: RoleViewMode) => {
  localStorage.setItem(ROLE_VIEW_MODE_STORAGE_KEY, mode);
};
